import { apiUrl } from "../../../../Constant/apiConstant"
import { getRequest, postJsonRequest } from "../../../../service/apiService"

export const getEmailTemplates = async(tenant: string | undefined)=>{
    try{
        const response= await getRequest(apiUrl.CM_GET_EMAIL_TEMPLATES,{},tenant,true)

        if(response.status === 200){
            const {Status,Data}=response.data

            if(Status){
                return Data
            }

            return []
        }
    }catch(error){
        console.log(error)
    }
    return []
}


export const saveEmailTemplate = async (tenant:string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.CM_POST_ADD_EMAIL_TEMPLATE,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,EmailNum}=response.data
            if(Status){
                return {EmailNum:EmailNum}
            }
            return null
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteEmailTemplate =async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.CM_POST_DELETE_EMAIL_TEMPLATE,payLoad,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false
}


export const getDashboardMessages = async(tenant: string | undefined)=>{
    try{
        const response= await getRequest(apiUrl.CM_GET_DASHBOARD_MESSAGES,{},tenant,true)

        if(response.status === 200){
            const {Status,Data}=response.data

            if(Status){
                return Data
            }

            return []
        }
    }catch(error){
        console.log(error)
    }
    return []
}

export const saveDashboardMessage = async (tenant:string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.CM_POST_ADD_DASHBOARD_MESSAGE,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,MessageNum}=response.data
            if(Status){
                return {MessageNum:MessageNum}
            }
            return null
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteDashboardMessage =async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.CM_POST_DELETE_DASHBOARD_MESSAGE,payLoad,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false
}

export const sendMultipleEmails = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.CM_POST_SEND_MULTIPLE_EMAILS,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Message}=response.data
            return {Status:Status,Message:Message}
        }
    }catch(error){
        console.log(error)
    }
    return {Status:false,Message:"Failed to send email.Please try again."}
}

export const getAllUserNums = async (tenant: string | undefined,payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.UM_GET_ALL_USER_NUMS,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Data} = response.data

            return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }
    return []
}

export const sendDashboardMessages= async(tenant: string | undefined,payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.CM_POST_SEND_DASHBOARD_MESSAGES,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Message}=response.data

            return {Status:Status,Message:Message}
        }
    }catch(error){
        console.log(error)
    }

    return {Status:false,Message:"Failed to send message.Please try again."}
}